import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import CommonDropdown from '../../../../../components/common-dropdown/CommonDropdown';
import WithLabel from '../../../../../components/with-label/WithLabel';
import OriginalSection from './sections/OriginalSection';
import PositiveSection from './sections/PositiveSection';
import NegativeSection from './sections/NegativeSection';
import ClusterRespondentsValue from '../../../cluster-respondents-value/ClusterRespondentsValue';
import useResonanceLoadingState from '../../../../hooks/useResonanceLoadingState';
import useConceptOptions from './hooks/useConceptOptions';
import { useProject } from '../../../../../context/ProjectContext';
import NoDataDisclaimer from '../no-data-disclaimer/NoDataDisclaimer';

import scss from './ConceptCompareSection.module.scss';

function ConceptCompareSection({ appliedFilters }) {
  const { t } = useTranslation('resonance');
  const { id: projectId } = useParams();
  const { actions } = useProject();

  const isConceptsLoading = useResonanceLoadingState('isConceptsLoading');
  const conceptsRespondents = useSelector((state) => state.resonance.conceptsRespondents);

  const [selectedConcept, setSelectedConcept] = useState(null);
  const conceptOptions = useConceptOptions();

  const handleSelectConcept = (concept) => {
    const newConcept = conceptOptions.find((option) => option.value === concept);

    setSelectedConcept(newConcept);
  };

  const isFiltersApplied = !!appliedFilters.length;

  useEffect(() => {
    if (!selectedConcept && conceptOptions?.length) {
      setSelectedConcept(conceptOptions[0]);
    }
  }, [conceptOptions, selectedConcept]);

  useEffect(() => {
    actions('getResonanceConcepts', { projectId, audiences: appliedFilters });
  }, [appliedFilters, projectId, actions]);

  if (conceptOptions && !conceptOptions.length) {
    return <NoDataDisclaimer title={t('noConceptsInTheProject')} />;
  }

  return (
    <div className={scss.wrapper}>
      <div className={scss.filterWrapper}>
        <div>
          <ClusterRespondentsValue clusterRespondents={isFiltersApplied ? conceptsRespondents : null} />
        </div>

        <WithLabel label={`${t('concept')}:`} isBold maxWidth={280}>
          <CommonDropdown
            options={conceptOptions ?? []}
            value={selectedConcept?.value}
            onSelect={handleSelectConcept}
            isLoading={isConceptsLoading}
          />
        </WithLabel>
      </div>

      <div className={scss.sectionsWrapper}>
        <OriginalSection selectedConcept={selectedConcept} isGlobalPercentageEnabled={isFiltersApplied} />
        <PositiveSection selectedConcept={selectedConcept} isGlobalPercentageEnabled={isFiltersApplied} />
        <NegativeSection selectedConcept={selectedConcept} isGlobalPercentageEnabled={isFiltersApplied} />
      </div>
    </div>
  );
}

export default ConceptCompareSection;
